import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class ArchiveApproveApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'archive-approve'
    }



    /**
     * 如果流程中全部通过-此流程完结
     * @param params 
     * @returns 
     */
    public update(params) {
        return this.send(params, "update", this.Methods.POST)
    }


   




}